import '../fesd/fesd'
import '../../sass/csr/csr_article.sass'
import { methods } from '../includes/_methods'
import { _dropdown } from '../includes/_dropdown.js'

$(function(){
  methods.lickSwitchClass('.row-dropdown.desktop li', 'active');
  _dropdown.all();
});